import { EntityActionNames, IEntityAction } from '../../app/spaces/ActionsMenu/EntityActions/IEntityAction';
import { anyLinkedTaskDisabledSchedule, userCanEditSchedule, userCanEnableLinkedTask } from '../../app/spaces/ActionsMenu/EntityActions/IEntityActionHelpers';
import { AppState } from '../../app/state/AppState';
import { Messages } from '../../codegen/Localize';
import { IScheduleInfo } from '../types/IScheduleInfo';
import { scheduleEnableLinkedTask } from './ScheduleMenuActions';

export const ScheduleEnableLinkedTaskAction: IEntityAction<IScheduleInfo, {}> = {
  name: EntityActionNames.EnableLinkedTask,
  translateName: Messages.linkedTasksEnable,
  isVisible: (targetItems: IScheduleInfo[], state: AppState) => {
    return targetItems.length > 0 && userCanEditSchedule(state, targetItems) && userCanEnableLinkedTask(targetItems);
  },
  isClickable: (_availableActions: {}, targetItems: IScheduleInfo[]) => {
    return anyLinkedTaskDisabledSchedule(targetItems);
  },
  createReduxAction: (targetItems: IScheduleInfo[]) => scheduleEnableLinkedTask(targetItems)
};
